import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

export interface InstanceStatusProps {
  progress?: number;
}

const InstanceStatus = ({ progress = 0.0 }:InstanceStatusProps) => {
  const intl = useIntl();

  return (
    <>
      <Typography
        variant='h4'
        color='primary'
        gutterBottom
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        {intl.formatMessage({ id: 'safescarfStatusLabel' })}
      </Typography>
      <Typography
        variant='h3'
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        {progress * 100}%
      </Typography>
    </>
  );
};

InstanceStatus.propTypes = { progress: PropTypes.number };

export default InstanceStatus;
